CommandeValidator.$inject = ['validator'];

export default function CommandeValidator(validator) {
    const instance = new validator();

    return instance;
}
